export enum CommonModalsEnum {
    GuestPicker = 'guests',
    Calendar = 'calendar',
    SearchEngine = 'searchEngine',
    InquiryForm = 'inquiryForm',
    InquiryFormSidebar = 'inquiryForm:sidebar',
    ChatForm = 'chatForm',
}
